import React from 'react';

const FormSection = ({ title, children }) => {
    return (
        <div className="mb-2 border-b border-primary pb-5 md:pb-0 md:border-0">
            <h6 className="h6 border-primary-gradient border-b-2 pb-2 mb-2 font-semibold">{title}</h6>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                <>{children}</>
            </div>
        </div>
    );
};

export default FormSection;
